import { Container, FlexRow, H1 } from "@utdanningsdirektoratet/lisa";
import React from "react";
import { P } from "../common/components/p";
import Utilgjengelig from "assets/elev/utilgjengelig.svg?react";
import { getElevAppSpecificContext } from "common/commonContext";
import { UnavailableContext } from "@generated/types/contextModels";

export const App: React.FC = () => {
	const { title, message } = getElevAppSpecificContext<UnavailableContext>();
	return (
		<>
			<H1 $textStyle="display">{title}</H1>
			<FlexRow wrap="wrap" halign="start" valign="start" width="100%" gap={40}>
				<Container padding={40} backgroundColor={"hvit"} maxWidth="550px">
					<P>{message}</P>
				</Container>
				<Utilgjengelig />
			</FlexRow>
		</>
	);
};
